import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../../../store/authenticationSlice';
import { AUTH_TOKEN } from '../../../constants/message';
import { encode } from '../../../utils/hashString';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../lib/axios';
import {
  EMPLOYEE_GET_OFFICER_BY_TOKEN,
  EMPLOYEE_LOGIN,
  OFFICER_PROFILE_FIND_ONE,
} from '../../../lib/endpoints/auth';

export const useLoginController = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation('global');

  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loggingIn, setLoggingIn] = useState<boolean>(false);

  const username = useRef<HTMLInputElement>(null!);
  const password = useRef<HTMLInputElement>(null!);

  const onSubmit = async (e: any) => {
    e.preventDefault();
    try {
      setLoggingIn(true);
      const { data } = await axios.post(
        EMPLOYEE_LOGIN,
        {
          username: username.current.value,
          password: password.current.value,
        },
        {
          headers: {
            'Accept-Language': 'lo',
          },
        }
      );

      const token: string = data?.data?.token;
      axios.defaults.headers.common['Authorization'] = token;
      axiosInstance.defaults.headers.common['Authorization'] = token;
      const { data: dataEmployee } = await axios.post(EMPLOYEE_GET_OFFICER_BY_TOKEN);
      // const { data: dataRefreshToken } = await axios.post(EMPLOYEE_REFRESH_TOKEN);
      const { data: dataEmployeeProfile } = await axios.get(OFFICER_PROFILE_FIND_ONE);
      dispatch(
        loginSuccess({
          ...dataEmployee,
          profile: dataEmployeeProfile,
        })
      );
      localStorage.setItem(
        AUTH_TOKEN,
        JSON.stringify({
          accessToken: encode(token),
          refreshToken: encode(data?.data?.refreshToken),
        })
      );
      navigate('/');
    } catch (err: any) {
      if (err?.response?.data?.message) {
        setErrorMessage(err?.response?.data?.message);
      } else {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoggingIn(false);
    }
  };

  return { onSubmit, username, password, errorMessage, loggingIn };
};
